import { useMediaQuery, useTheme } from '@mui/material'

// Form-heavy and multi-step dialogs should fill the screen on phones rather
// than float as a cramped box. Pass the result straight to <Dialog fullScreen>.
// Dialogs are never open during SSR, so the server-side `false` never renders.
//
// The theme is read with @mui/material's `useTheme`, which falls back to the
// default theme outside a ThemeProvider, rather than handing useMediaQuery a
// `(theme) => …` callback: that form receives `null` without a provider and
// throws, which breaks every plain `renderToStaticMarkup` component test that
// renders a converted dialog.
export function useFullScreenDialog(breakpoint = 'sm') {
    const theme = useTheme()
    return useMediaQuery(theme.breakpoints.down(breakpoint))
}
